<div
  class="w-full overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white shadow-xl dark:border-surface-3 dark:bg-surface-1"
  (click)="$event.stopPropagation()"
>
  <div class="relative px-6 pb-2 pt-6">
    <button
      type="button"
      (click)="close()"
      class="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#f2f5f8] text-[#7d7d93] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
      aria-label="Close"
    >
      <app-icon-v2 name="x" size="16"></app-icon-v2>
    </button>

    <h3 class="pr-10 text-left text-[20px] font-bold leading-snug text-[#141437] dark:text-white">
      {{ title }}
    </h3>

    @if (isConfirmMode) {
      @if (totalAmount) {
        <div class="mt-5 rounded-[10px] bg-[#f4edff] px-5 py-5 dark:bg-purple-500/10">
          <p class="text-[14px] text-[#7d7d93] dark:text-ink-muted">You are Paying:</p>
          <p class="mt-1 text-[36px] font-bold leading-tight text-[#141437] dark:text-white">
            {{ totalAmount | currency }}
          </p>
        </div>
      }

      @if (paymentCount != null) {
        <p class="mt-4 text-left text-[14px] text-[#7d7d93] dark:text-ink-muted">
          No. of Payments:
          <span class="font-semibold text-[#141437] dark:text-white">{{ paymentCount }}</span>
        </p>
      }

      @if (disabledMessage) {
        <p class="mt-3 text-[14px] font-medium text-[#f05050] dark:text-[#ff9090]">{{ disabledMessage }}</p>
      }
    } @else {
      @if (paymentCount != null) {
        <p class="mt-4 text-left text-[14px] text-[#7d7d93] dark:text-ink-muted">
          No. of Payments:
          <span class="font-semibold text-[#141437] dark:text-white">{{ paymentCount }}</span>
        </p>
      } @else if (contractId) {
        <p class="mt-4 text-left text-[14px] text-[#7d7d93] dark:text-ink-muted">
          Contract ID:
          <span class="font-semibold text-[#141437] dark:text-white">{{ contractId }}</span>
        </p>
      }

      @if (message) {
        <p class="mt-4 text-left text-[14px] text-[#38385b] dark:text-ink-soft">
          {{ message }}
        </p>
      }

      <div class="mt-4">
        @if (useTextarea) {
          <textarea
            rows="4"
            autocomplete="off"
            maxlength="200"
            class="min-h-[100px] w-full resize-y rounded-[10px] border border-[#d1d5dc] bg-white px-3 py-2.5 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:border-[#7c3aed] focus:ring-2 focus:ring-[#7c3aed]/20 dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
            [(ngModel)]="note"
            [placeholder]="inputPlaceholder"
          ></textarea>
        } @else {
          <input
            type="text"
            autocomplete="off"
            maxlength="200"
            class="h-[44px] w-full rounded-[10px] border border-[#d1d5dc] bg-white px-3 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:border-[#7c3aed] focus:ring-2 focus:ring-[#7c3aed]/20 dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
            [(ngModel)]="note"
            [placeholder]="inputPlaceholder"
          />
        }
      </div>
    }
  </div>

  <div class="px-6 pb-6 pt-4">
    @if (isConfirmMode) {
      <div class="flex gap-3">
        <button
          type="button"
          class="inline-flex h-11 flex-1 items-center justify-center rounded-[10px] bg-[#ececf0] text-[14px] font-semibold text-[#7d7d93] transition hover:bg-[#e2e2e8] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
          (click)="close()"
        >
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          class="inline-flex h-11 flex-1 items-center justify-center rounded-[10px] bg-[#ad46ff] text-[14px] font-semibold text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="!canSubmit"
          (click)="confirm()"
        >
          {{ confirmLabel }}
        </button>
      </div>
    } @else {
      <app-button
        type="button"
        variant="primary"
        size="lg"
        className="!w-full !rounded-[10px]"
        (click)="confirm()"
        [disabled]="!canSubmit"
      >
        {{ confirmLabel }}
      </app-button>
    }
  </div>
</div>
